import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import Select from 'react-select';

export const InstitutionField = ({ institutionOptions = [], value, onChange }) => {
    if (institutionOptions.length === 1) {
        return (
            <FormGroup>
                <Label>Institution</Label>
                <div className="form-control-plaintext">{institutionOptions[0].label}</div>
            </FormGroup>
        );
    }

    return (
        <FormGroup>
            <Label for="institution-select">Institution</Label>
            <Select
                inputId="institution-select"
                options={institutionOptions}
                value={institutionOptions.find((o) => o.value === value) ?? null}
                onChange={(opt) => onChange(opt?.value ?? null)}
                placeholder="Select institution..."
                isClearable
            />
        </FormGroup>
    );
};
